import * as React from 'react';
import s from './Logo.scss';
import { getLogoUrl } from './getLogoUrl';
export const Logo = ({ onImageReady = () => { }, logo, mobileView = false }) => {
    const hasLogo = () => logo && logo.match(/(?:[^\/]+)$/);
    const handleLogoNotExist = () => {
        onImageReady();
        return React.createElement("div", { style: { height: mobileView ? '' : '10px' } });
    };
    return hasLogo() ? (React.createElement("div", { className: s.logo, "data-hook": "business-logo" },
        React.createElement("img", { decoding: "sync", src: getLogoUrl(logo, { maxWidth: 622, maxHeight: 200 }), onError: ({ target: image }) => {
                image.parentElement.style.display = 'none';
                onImageReady();
            }, onLoad: onImageReady }))) : (handleLogoNotExist());
};
//# sourceMappingURL=Logo.js.map